import React, { useEffect, useMemo } from 'react'
import { Button } from 'antd'
import { CloseOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons'
import ImageWithLoader from './ImageWithLoader'
import IframeWithLoader from './IframeWithLoader'

export default function Preview({ files, id, setId, hasMore, fetchNextFiles }) {
  const currIndex = useMemo(() => files?.findIndex(f => f.id === id), [files, id])
  const curr = useMemo(() => files?.[currIndex], [currIndex, files])
  const prev = useMemo(() => files?.[currIndex - 1], [currIndex, files])
  const next = useMemo(() => files?.[currIndex + 1], [currIndex, files])
  const next2 = useMemo(() => files?.[currIndex + 2], [currIndex, files])

  useEffect(() => {
    if (hasMore && !next2) {
      fetchNextFiles()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currIndex])

  if (!curr) return null

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: 8,
        gap: 8,
      }}
    >
      <div />
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
        <Button onClick={() => setId(null)} icon={<CloseOutlined />} style={{ visibility: 'hidden' }} />
        <Button type="primary" disabled={!prev} onClick={() => setId(prev?.id)} icon={<LeftOutlined />} />
        <Button onClick={() => setId(null)} icon={<CloseOutlined />} style={{ visibility: 'hidden' }} />
      </div>
      <div
        style={{
          flexGrow: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '-webkit-fill-available',
        }}
      >
        {curr.hdUrl && (
          <ImageWithLoader
            src={curr.hdUrl}
            style={{
              borderRadius: 8,
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain',
            }}
          />
        )}
        {!curr.hdUrl && <IframeWithLoader src={curr.fileUrl || curr.url} />}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
        <Button onClick={() => setId(null)} icon={<CloseOutlined />} />
        <Button type="primary" disabled={!next} onClick={() => setId(next.id)} icon={<RightOutlined />} />
        <Button onClick={() => setId(null)} icon={<CloseOutlined />} style={{ visibility: 'hidden' }} />
      </div>
      <div />
    </div>
  )
}
